import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-call-to-action-pay-in-installments-by-credit-card",
    imports: [TranslateModule],
    templateUrl: "./call-to-action-pay-in-installments-by-credit-card.component.html",
    styleUrl: "./call-to-action-pay-in-installments-by-credit-card.component.scss"
})
export class CallToActionPayInInstallmentsByCreditCardComponent {}
